import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getBulkDropdownData } from "../../api/keyvalue";
import Dropdown from "../input/Dropdown";
import { FORMS, MODULES } from "../../const";
import { toast } from "react-toastify";
import Button from "../input/Button";
import { bulkVehicleStatusChange } from "../../api/vehicleapi";
import Input from "../input/Input";

const VehicleStatusChange = ({ vehIds, closeModal }) => {
  const [vehicleData, setVehicleData] = useState({
    vehActive: "",
    vehStatus: "",
    vehRemark: "",
  });
  const user = useSelector((state) => state.user);
  const FORM = FORMS.VEHICLE.VEH_DETAIL.form;

  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  console.log("vehicle ids", vehIds);

  useEffect(() => {
    (async () => {
      const { active = [], vehicle_status: statusOpts } =
        await getBulkDropdownData([
          { key: "active" },
          { key: "vehicle_status" },
        ]);
      setActiveOptions(active);
      setStatusOptions(statusOpts);
    })();
  }, []);

  const bulkUpdateStatus = async () => {
    if (!vehicleData.vehActive || !vehicleData.vehStatus) {
      toast.error("Please select Active and Status values!", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }
    try {
      const bulkUpdateStatusChangeRequest = {
        vehIds: vehIds,
        vehActive: vehicleData.vehActive,
        vehStatus: vehicleData.vehStatus,
        vehRemark: vehicleData.vehRemark,
        author: user?.username,
      };
      console.log("bulk update status", bulkUpdateStatusChangeRequest);
      const response = await bulkVehicleStatusChange(
        bulkUpdateStatusChangeRequest,
      );

      toast.success("Vehicle Status Changed Successfully", {
        autoClose: 1000,
        containerId: "Modal",
      });
      setVehicleData({
        vehActive: "",
        vehStatus: "",
      });
      setTimeout(() => {
        closeModal();
      }, 2000);
    } catch (e) {
      console.error(e);
      toast.error("Failed to update status.", {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing headder">Change Status</h4>
          <div className="ui segment">
            <div className="two fields">
              <Dropdown
                required={true}
                label="Active"
                module={MODULES.Master}
                field="veh_active"
                placeholder="Active"
                style={{ height: "20px" }}
                options={activeOptions}
                form={FORM}
                value={vehicleData.vehActive}
                onChange={(e, data) => {
                  setVehicleData((prevState) => ({
                    ...prevState,
                    vehActive: data.value,
                  }));
                }}
              />
              <Dropdown
                label="Status"
                required={true}
                module={MODULES.Master}
                form={FORM}
                field="veh_status"
                placeholder="Status"
                options={statusOptions}
                value={vehicleData.vehStatus}
                style={{ height: "20px" }}
                onChange={(e, data) => {
                  setVehicleData((prevState) => ({
                    ...prevState,
                    vehStatus: data.value,
                  }));
                }}
              />
            </div>
            <div>
              <Input
                label="Remarks"
                field="veh_remarks"
                placeholder="Remarks"
                value={vehicleData.vehRemark}
                onChange={(e, data) => {
                  setVehicleData((prevState) => ({
                    ...prevState,
                    vehRemark: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                label="Update"
                authenticated={true}
                form={FORMS.VEHICLE.VEH_STATUS.form}
                module={MODULES.Master}
                onClick={bulkUpdateStatus}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default VehicleStatusChange;
